import React from 'react';
import useEnqueueTrigger from '../Contexts/SessionConnectionContextProvider/Hooks/useEnqueueTrigger';
import useAudioServerCommunication from './useAudioServerCommunication';
import useStopSession from './useStopSession';

export default function useHandleSessionTimeout() {
  const enqueueTrigger = useEnqueueTrigger();
  const stopSession = useStopSession();
  const { lastJsonMessage } = useAudioServerCommunication();

  React.useEffect(() => {
    if (lastJsonMessage && lastJsonMessage.type === 'sessionTimeout') {
      enqueueTrigger(
        'sessionTimeout',
        'body',
        () => { stopSession('SessionTimeout'); },
      );
    }
  }, [lastJsonMessage]);
}
